<script>
import { getDates } from '@/services/DateServices';
import { getProgramFromDbase } from '@/services/ProgramServices';
import { addSmallTaskToToday } from '@/services/SmallTasksServices';
import { createBigTask } from '@/services/BigTaskServices';
import {
  addDaysToDate, getDisplayDateFromRawDate, getLatestWRPFromDbase, getReviewStartDateOptions, getLocalDateString,
  createNewWRP, getADayToReviewFromDbase,
  getWRPDraft, saveWRPDraft, deleteWRPDraft,
} from '@/services/WeeklyReviewPreviewServices';
import CalWeekReview from './components/CalWeekReview.vue';
import CalWeekPreview from './components/CalWeekPreview.vue';
import TableWins from './components/TableWins.vue';
import StackedGraphics from './components/StackedGraphics.vue';

export default {
  components: { CalWeekReview, CalWeekPreview, TableWins, StackedGraphics },
  data() {
    return {
      // draft WRP
      draftCreatedAt: null,
      draftSaveShowAlert: false,
      loadingSaveDraft: false,
      loadingDiscardDraft: false,

      wrpStarted: false,
      loading: false,
      expandedStep: '1',

      // user
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      program: null, // array of objects
      latestWRP: null, // WRP Object
      yesRecentWRPTarget: false, // whether this.latestWRP applies to this.weekToReview
      // dates
      todayDate: null,
      todayDateDisplay: null,
      dateOfReview: null,
      // date-picker
      tomorrowDate: null,
      reviewStartDateOptions: null, // array of objects {value, display}
      selectedReviewStartDate: null, // 'YYYY-MM-DD'
      weekToReview: null, // array of objects {value, display}
      weekToPreview: null, // array of objects {value, display}
      // wrp data
      dataWeekToReview: null, // object of objects - keys are the dates
      dataWeekToPreview: null, // object of objects - keys are the dates
      // step 1 - target for this past week
      onTheFlyTargetGoal: '',
      targetForThisPastWeek: '',
      hitThisPastWeekTarget: '0',
      // step 2 - review the past week
      showReviewDetailsByDay: false,
      stackedWins: null,
      totalPossibleWins: null,
      countStackedWinsByDay: {},
      stackedBigTasks: null,
      totalPossibleBigTasks: null,
      countStackedBigTasksByDay: {},
      stackedSmallTasks: null,
      totalPossibleSmallTasks: null,
      countStackedSmallTasksByDay: {},
      // step 2 - self-review
      rateYourPerformanceDescriptions: {
        1: 'abysmal',
        2: 'not good',
        3: 'alright',
        4: 'pretty good',
        5: 'superhero',
      },
      rateYourPerformance: null,
      unexpectedObstacles: '',
      whatWorkedForYou: '',
      whatWouldYouDoDifferently: '',
      // step 3 - preview the upcoming week
      showPreviewAddField: '1',
      newTasksAddedToUpcomingWeek: {},
      addBirthdayDate: null,
      addBirthday: '',
      addBirthdayCount: 0,
      addPersonalDate: null,
      addPersonal: '',
      addPersonalCount: 0,
      addMainTaskDate: null,
      addMainTaskTitle: '',
      addMainTaskDescription: '',
      addMainTaskCount: 0,
      finishedTimeBlocking: false,
      // step 4 - main target/goals for upcoming week
      mainTargetForUpcomingWeek: '',
      // step 5 - review & save
      loadingStep5: false,
    };
  },
  watch: {
    expandedStep() {
      if (this.expandedStep === '3') {
        this.showPreviewAddField = '1';
      }
    },
  },
  computed: {
    draftWRP() {
      return {
        // USER info
        program: this.program,
        latestWRP: this.latestWRP,
        yesRecentWRPTarget: this.yesRecentWRPTarget,
        targetForThisPastWeek: this.targetForThisPastWeek,

        // WRP status
        wrpStarted: this.wrpStarted,
        expandedStep: this.expandedStep,

        // WRP dates
        selectedReviewStartDate: this.selectedReviewStartDate,
        dateOfReview: this.dateOfReview,
        weekToReview: this.weekToReview,
        dataWeekToReview: this.dataWeekToReview,
        weekToPreview: this.weekToPreview,
        dataWeekToPreview: this.dataWeekToPreview,

        // STEP 1
        onTheFlyTargetGoal: this.onTheFlyTargetGoal,
        hitThisPastWeekTarget: this.hitThisPastWeekTarget,

        // STEP 2
        rateYourPerformance: this.rateYourPerformance,
        unexpectedObstacles: this.unexpectedObstacles,
        whatWorkedForYou: this.whatWorkedForYou,
        whatWouldYouDoDifferently: this.whatWouldYouDoDifferently,

        // STEP 3
        newTasksAddedToUpcomingWeek: this.newTasksAddedToUpcomingWeek,
        addBirthdayCount: this.addBirthdayCount,
        addPersonalCount: this.addPersonalCount,
        addMainTaskCount: this.addMainTaskCount,
        finishedTimeBlocking: this.finishedTimeBlocking,

        // STEP 4
        mainTargetForUpcomingWeek: this.mainTargetForUpcomingWeek,

        // STEP 5
      };
    },
    step2WinsSummaryTableRows() {
      const categories = ['wins', 'bigtask', 'smalltasks'];
      const rowLabels = ['Wins', 'Big Tasks', 'Small Tasks'];

      return categories.map((catKey, rowIndex) => {
        const row = {
          label: rowLabels[rowIndex],
          cells: []
        };

        Object.keys(this.dataWeekToReview).sort().forEach(dateStr => {
          const dayData = this.dataWeekToReview[dateStr] || {};
          const category = dayData[catKey] || {};

          let total = 0;
          let stackedCount = 0;

          if (catKey === 'wins') {
            // NEW LOGIC - skip spacer wins
            Object.values(category).forEach(win => {
              // MINIMUM 12 equal signs to be excluded as a spacer (reco: 25+)
              if (!win.win?.includes('============')) {
                total++;
                if (win.stacked === true) {
                  stackedCount++;
                }
              }
            });
          }
          else if (catKey === 'bigtask') {
            total = category.title ? 1 : 0;
            stackedCount = total === 1 && category.stacked ? 1 : 0;
          }
          else {
            // smalltasks
            total = Object.keys(category)?.length || 0;
            stackedCount = Object.values(category).filter(item => item.stacked === true).length;
          }

          const hasStacked = stackedCount > 0;

          let newThing = {
            date: dateStr,
            stacked: stackedCount,
            total: total,
            display: total > 0 ? `${stackedCount} of ${total}` : 'n/a',
          };

          if (catKey !== 'bigtask') {
            newThing.showCheck = hasStacked;
          }

          row.cells.push(newThing);
        });

        return row;
      });
    },
    modalWinsDetailTableRows() {
      if (!this.dataWeekToReview || !this.program || !this.weekToReview) return [];

      return this.program.map((progWin) => {
        let row = {
          programId: progWin.id,
          order: progWin.order || '',
          winText: progWin.win,
          cells: {}
        };

        this.weekToReview.forEach((dayObj) => {
          const dateKey = dayObj.value;
          const dayData = this.dataWeekToReview[dateKey];
          let stacked = false;

          if (dayData?.wins) {
            Object.values(dayData.wins).forEach((winEntry) => {
              // Skip spacers here too - MINIMUM 12 equal signs to be excluded as a spacer (reco: 25+)
              if (winEntry.programId === progWin.id && !winEntry.win?.includes('============')) {
                stacked = !!winEntry.stacked;
              }
            });
          }

          row.cells[dateKey] = { stacked };
        });

        return row;
      });
    },
  },
  methods: {
    async loadDraft(draft) {
      if (!draft?.data) {
        return;
      }

      this.draftCreatedAt = draft.createdAt || null;

      // USER info
      this.program = draft.data.program;
      this.latestWRP = draft.data.latestWRP;
      this.yesRecentWRPTarget = draft.data.yesRecentWRPTarget;
      this.targetForThisPastWeek = draft.data.targetForThisPastWeek;

      // WRP status
      this.wrpStarted = draft.data.wrpStarted;
      this.expandedStep = draft.data.expandedStep;

      // WRP dates
      this.selectedReviewStartDate = draft.data.selectedReviewStartDate;
      this.dateOfReview = draft.data.dateOfReview;
      this.weekToReview = draft.data.weekToReview;
      this.dataWeekToReview = draft.data.dataWeekToReview;
      this.weekToPreview = draft.data.weekToPreview;
      this.dataWeekToPreview = draft.data.dataWeekToPreview;

      // STEP 1
      this.onTheFlyTargetGoal = draft.data.onTheFlyTargetGoal;
      this.hitThisPastWeekTarget = draft.data.hitThisPastWeekTarget;

      // STEP 2
      this.rateYourPerformance = draft.data.rateYourPerformance;
      this.unexpectedObstacles = draft.data.unexpectedObstacles;
      this.whatWorkedForYou = draft.data.whatWorkedForYou;
      this.whatWouldYouDoDifferently = draft.data.whatWouldYouDoDifferently;

      // STEP 3
      this.newTasksAddedToUpcomingWeek = draft.data.newTasksAddedToUpcomingWeek || {};

      this.addBirthdayCount = draft.data.addBirthdayCount || 0;
      this.addPersonalCount = draft.data.addPersonalCount || 0;
      this.addMainTaskCount = draft.data.addMainTaskCount || 0;
      this.finishedTimeBlocking =
      draft.data.finishedTimeBlocking || false;

      // STEP 4
      this.mainTargetForUpcomingWeek = draft.data.mainTargetForUpcomingWeek || '';

      await this.$nextTick();

      if (this.dataWeekToReview) {
        this.getStackedCounts(this.dataWeekToReview);
      }

      console.log('*** WRP draft loaded from RTDB ***', draft);
    },
    async clearDraft() {
      await deleteWRPDraft(this.uId, this.token);
      this.draftCreatedAt = null;

      console.log('*** WRP draft deleted from RTDB ***');
    },
    async discardDraftStartOver() {
      this.loadingDiscardDraft = true;

      try {
        await this.clearDraft();
        window.location.reload();
      } catch (error) {
        console.error('*** Failed to discard WRP draft ***', error);
        alert('The WRP draft could not be discarded. Please try again.');
        this.loadingDiscardDraft = false;
      }
    },
    async saveDraft() {
      if (this.loadingSaveDraft) {
        return false;
      }

      this.loadingSaveDraft = true;

      try {
        // const now = new Date().toISOString();
        const today = getLocalDateString();

        if (!this.draftCreatedAt) {
          this.draftCreatedAt = today;
        }

        const draftToSave = {
          data: this.draftWRP,
          createdAt: this.draftCreatedAt,
          updatedAt: today,
        };

        await saveWRPDraft(this.uId, this.token, draftToSave);

        this.draftSaveShowAlert = true;

        console.log('*** WRP draft saved to RTDB ***', draftToSave);

        return true;
      } catch (error) {
        console.error('*** Failed to save WRP draft ***', error);

        // Replace this with your normal error-alert system if you have one.
        alert('The WRP draft could not be saved. Please try again.');

        return false;
      } finally {
        this.loadingSaveDraft = false;
      }
    },
    getLocalDateFromString(dateString) {
      if (
      typeof dateString !== 'string' ||
      !/^\d{4}-\d{2}-\d{2}$/.test(dateString)
      ) {
        return null;
      }

      const [year, month, day] =
      dateString.split('-').map(Number);

      const date = new Date(
      year,
      month - 1,
      day
      );

      // Reject impossible dates such as 2026-02-31.
      if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
      ) {
        return null;
      }

      return date;
    },

    // step progression
    async goToStep(step) {
      const saved = await this.saveDraft();

      // Do not advance if the draft failed to save.
      if (!saved) {
        return;
      }

      this.expandedStep = step;

      await this.$nextTick();

      window.scrollTo({ top: 400, left: 0, behavior: 'smooth', });
    },
    
    // step 0 - datepicker
    handleChangeToReviewStartDate(newValue) {
      if (!newValue) return;
      this.newReviewStartDateSelected(newValue);
    },
    newReviewStartDateSelected(selectedDate) {
      const psd = addDaysToDate(selectedDate, 7);
      let reviewDates = [];
      let previewDates = [];

      for (let i = 0; i < 7; i++) {
        // review dates
        const rv = addDaysToDate(selectedDate, i);
        reviewDates.push({
          ...getDisplayDateFromRawDate(rv),
          value: rv,
        });
        // preview dates
        const pv = addDaysToDate(psd, i);
        previewDates.push({
          ...getDisplayDateFromRawDate(pv),
          value: pv,
        });
      }

      this.weekToReview = reviewDates;
      this.weekToPreview = previewDates;
    },
    openAllDaysToReviewInNewTabs() {
      console.log('*** weekToReview ***', this.weekToReview);
      this.weekToReview.forEach(day => {
        window.open(`/dash/${day.value}`, '_blank');
      });
    },

    // spark it up, sparky
    async startWRP() {
      console.log('*** startWRP() ***');

      // UI - show loading
      this.loading = true;

      this.dateOfReview = {
        value: this.todayDate,
        display: this.todayDateDisplay,
      };

      // get data for weekToReview
      let review = {};
      for (let day of this.weekToReview) {
        review[day.value] = await getADayToReviewFromDbase(this.uId, this.token, day.value);
      }
      this.dataWeekToReview = review;
      // console.log('*** got all the days to review data ***', this.weekToReview, this.dataWeekToReview);


      // get data for weekToPreview
      let preview = {};
      for (let day of this.weekToPreview) {
        preview[day.value] = await getADayToReviewFromDbase(this.uId, this.token, day.value);
        this.newTasksAddedToUpcomingWeek[day.value] = [];
      }
      this.dataWeekToPreview = preview;
      // console.log('*** got all the days to preview data ***', this.weekToPreview, this.dataWeekToPreview);



      // step 1 - check if this.latestWRP applies to this.weekToReview
      if (this.latestWRP) {
        const dateKey = Object.keys(this.latestWRP)[0];
        const datesWTReview = this.weekToReview?.map(d => d.value);
        const targetWeek = this.latestWRP[dateKey].weekToPreview?.map(d => d.value);
        this.yesRecentWRPTarget = datesWTReview?.some(d => targetWeek?.includes(d));
        if (this.yesRecentWRPTarget) {
          this.targetForThisPastWeek = this.latestWRP[dateKey].mainTargetForUpcomingWeek;
        }
      }


      // step 2 - get the stacked counts
      this.getStackedCounts(review);


      // set step 3 dates
      this.addBirthdayDate = this.addPersonalDate = this.addMainTaskDate = this.weekToPreview[0].value;


      // UI
      this.loading = false;
      this.wrpStarted = true;

      await this.$nextTick();

      window.scrollTo({ top: 400, left: 0, behavior: 'smooth' });
    },

    // step 1
    // count how many wins were stacked during the weekToReview
    getStackedCounts(review) {
      // console.log('*** review review review ***', Object.keys(review), review);

      const dates = Object.keys(review);
      for (let date of dates) {
        const day = review[date];
        // console.log('**** date ****', date, '*** day ****', day);
        let stackedWinsCountForDay = 0;
        let totalPossibleWinsForDay = 0;
        let stackedSmallTasksCountForDay = 0;
        let totalPossibleSmallTasksCountForDay = 0;
        let stackedBigTaskCountForDay = 0;
        let totalPossibleBigTaskCountForDay = 0;

        if (day?.wins) {
          Object.keys(day.wins).forEach(id => {
            const win = day.wins[id];
            // MINIMUM 12 equal signs to be excluded as a spacer (reco: 25+)
            if (!win.win.includes('============')) {
              this.totalPossibleWins = this.totalPossibleWins + 1;
              totalPossibleWinsForDay = totalPossibleWinsForDay + 1;

              if (win.stacked) {
                this.stackedWins = this.stackedWins + 1;
                stackedWinsCountForDay = stackedWinsCountForDay + 1;
              }
            }



          });
        }
        if (day?.bigtask) {
          this.totalPossibleBigTasks = this.totalPossibleBigTasks + 1;
          totalPossibleBigTaskCountForDay = 1;
          if (day.bigtask.stacked) {
            this.stackedBigTasks = this.stackedBigTasks + 1;
            stackedBigTaskCountForDay = 1;
          }
        }
        if (day?.smalltasks) {
          Object.keys(day.smalltasks).forEach(id => {
            const st = day.smalltasks[id];
            this.totalPossibleSmallTasks = this.totalPossibleSmallTasks + 1;
            totalPossibleSmallTasksCountForDay = totalPossibleSmallTasksCountForDay + 1;
            if (st.stacked) {
              this.stackedSmallTasks = this.stackedSmallTasks + 1;
              stackedSmallTasksCountForDay = stackedSmallTasksCountForDay + 1;
            }
          });
        }

        this.countStackedWinsByDay[date] = {
          stacked: stackedWinsCountForDay,
          total: totalPossibleWinsForDay,
        };
        this.countStackedBigTasksByDay[date] = {
          stacked: stackedBigTaskCountForDay,
          total: totalPossibleBigTaskCountForDay,
        };
        this.countStackedSmallTasksByDay[date] = {
          stacked: stackedSmallTasksCountForDay,
          total: totalPossibleSmallTasksCountForDay,
        };

      } // endfor (date of dates)
    },

    // step 2
    selectPerformanceRating(i) {
      this.rateYourPerformance = i;
    },

    // step 3
    showPreviewAddSection(s) {
      this.showPreviewAddField = s;
    },
    async addNewBirthday() {
      // api call - add birthday
      // addBirthdayDate: null,
      // addBirthday: '',
      // console.log('*** add a birthday ***', this.addBirthdayDate, this.addBirthday);
      const newTask = {
        task: `BIRTHDAY - ${this.addBirthday}`,
        stacked: false,
        dateCreated: this.todayDate,
        dateUpdated: this.todayDate,
      };
      const created = await addSmallTaskToToday(this.uId, this.token, this.addBirthdayDate, newTask);
      if (created) {
        // const dateCell = document.getElementById(`preview-row-new-small-tasks-${this.addBirthdayDate}`);
        // if (dateCell) {
        //   // append a new html element <li>...</li>
        //   const newLi = document.createElement('li');
        //   newLi.innerHTML = `BIRTHDAY - ${this.addBirthday}`;
        //   dateCell.appendChild(newLi);
        // }
        this.newTasksAddedToUpcomingWeek[this.addBirthdayDate].push(newTask.task);

        this.addBirthdayCount = this.addBirthdayCount + 1;
        // this.addBirthdayDate = this.weekToPreview[0].value;
        this.addBirthday = '';
      }

    },
    async addNewPersonal() {
      // api call - add personal event
      // addPersonalDate: null,
      // addPersonal: '',
      const newTask = {
        task: this.addPersonal,
        stacked: false,
        dateCreated: this.todayDate,
        dateUpdated: this.todayDate,
      };
      const created = await addSmallTaskToToday(this.uId, this.token, this.addPersonalDate, newTask);
      if (created) {
        // const dateCell = document.getElementById(`preview-row-new-small-tasks-${this.addPersonalDate}`);
        // if (dateCell) {
        //   // append a new html element <li>...</li>
        //   const newLi = document.createElement('li');
        //   newLi.innerHTML = this.addPersonal;
        //   dateCell.appendChild(newLi);
        // }
        this.newTasksAddedToUpcomingWeek[this.addPersonalDate].push(newTask.task);
        this.addPersonalCount = this.addPersonalCount + 1;
        // this.addPersonalDate = this.weekToPreview[0].value;
        this.addPersonal = '';

      }


    },
    async addNewMainTask() {
      // api call - add big Task
      // addMainTaskDate: null,
      // addMainTaskTitle: '',
      // addMainTaskDescription: '',
      const newBigTask = {
        title: this.addMainTaskTitle.trim(),
        description: this.addMainTaskDescription.trim(),
        stacked: false,
        dateCreated: this.todayDate,
        dateUpdated: this.todayDate,
      };
      const created = await createBigTask(this.uId, this.token, this.addMainTaskDate, newBigTask);
      if (created?.bigtask) {
        // const dateCell = document.getElementById(`preview-row-new-small-tasks-${this.addMainTaskDate}`);
        // if (dateCell) {
        //   // append a new html element <li>...</li>
        //   const newLi = document.createElement('li');
        //   newLi.innerHTML = `<b>${this.addMainTaskTitle}</b><br /><p>${this.addMainTaskDescription}</p>`;
        //   dateCell.appendChild(newLi);
        // }
        this.newTasksAddedToUpcomingWeek[this.addMainTaskDate].push(`${newBigTask.title} - ${newBigTask.description}`);
        this.addMainTaskCount = this.addMainTaskCount + 1;
        // this.addMainTaskDate = this.weekToPreview[0].value;
        this.addMainTaskTitle = '';
        this.addMainTaskDescription = '';
      }
    },

    // step 5
    async finishAndSaveWRP() {
      // console.log('*** starting finishAndSaveWRP() ***');
      this.loadingStep5 = true;

      let wrpObject = {
        // dates
        dateOfReview: this.dateOfReview,
        weekToReview: this.weekToReview,
        weekToPreview: this.weekToPreview,

        // step 1
        hitThisPastWeekTarget: this.hitThisPastWeekTarget,

        // step 2
        stackedWins: this.stackedWins, // total wins stacked
        totalPossibleWins: this.totalPossibleWins, // total wins possible
        // bigTasks count
        stackedBigTasks: this.stackedBigTasks, // total bigTasks stacked
        totalPossibleBigTasks: this.totalPossibleBigTasks, // total bigTasks possible
        // smallTasks count
        stackedSmallTasks: this.stackedSmallTasks, // total smallTasks stacked
        totalPossibleSmallTasks: this.totalPossibleSmallTasks, // total smallTasks possible
        // self-review notes
        winsStackedDetailsForModal: this.modalWinsDetailTableRows,
        // step 2 - self-review
        rateYourPerformance: this.rateYourPerformance, // rate yourself
        unexpectedObstacles: this.unexpectedObstacles, // unexpected obstacles
        whatWorkedForYou: this.whatWorkedForYou, // what worked
        whatWouldYouDoDifferently: this.whatWouldYouDoDifferently, // what do you want to do better next time
        // step 3 - preview upcoming week
        newTasksAddedToUpcomingWeek: this.newTasksAddedToUpcomingWeek,
        addBirthdayCount: this.addBirthdayCount,
        addPersonalCount: this.addPersonalCount,
        addMainTaskCount: this.addMainTaskCount,
        finishedTimeBlocking: this.finishedTimeBlocking,
        // main target / goal for upcoming week
        mainTargetForUpcomingWeek: this.mainTargetForUpcomingWeek,
      };

      // step 1 conditionals
      if (this.yesRecentWRPTarget) {
        wrpObject.targetForThisPastWeek = this.targetForThisPastWeek;
      } else {
        wrpObject.onTheFlyTargetGoal = this.onTheFlyTargetGoal;
        if (this.onTheFlyTargetGoal.length > 0) {
          wrpObject.targetForThisPastWeek = `ON THE FLY - ${this.onTheFlyTargetGoal}`;
        }
      }

      // save to dbase
      // console.log('*** finishAndSaveWRP() > new WRP object ***', wrpObject);
      const success = await createNewWRP(this.uId, this.token, wrpObject);
      if (success) {
        console.log('**** successfully saved new WRP ******');

        await this.clearDraft();

        window.scrollTo(0, 0);
        window.location.href = '/wrp/all';
      }
    },


  },
  async created() {
    console.clear();
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    // get dates
    const dateObject = getDates();

    this.todayDate = dateObject.todayActual;
    this.tomorrowDate = dateObject.tomorrowActual;

    const tDD = getDisplayDateFromRawDate(this.todayDate)
    this.todayDateDisplay = tDD.display;

    this.dateOfReview = { value: this.todayDate, display: this.todayDateDisplay };

    // select the first available sunday as the review start date
    this.reviewStartDateOptions = getReviewStartDateOptions(this.todayDate, this.tomorrowDate);

    const srsd = [...this.reviewStartDateOptions].reverse().find( option => option.display.includes('Sun') );
    this.selectedReviewStartDate = srsd.value;

    this.newReviewStartDateSelected(this.selectedReviewStartDate);


    // Check RTDB for an existing WRP draft.
    const draft = await getWRPDraft(this.uId, this.token);

    let validDraft = draft;

    if (draft) {
      const updatedAtDate =
      this.getLocalDateFromString(
      draft.updatedAt
      );

      const todayDate =
      this.getLocalDateFromString(
      getLocalDateString()
      );

      const invalidUpdatedAt =
      !updatedAtDate || !todayDate;

      let draftIsExpired = invalidUpdatedAt;

      if (!invalidUpdatedAt) {
        const millisecondsPerDay = 24 * 60 * 60 * 1000;

        const ageInDays = Math.floor( (todayDate.getTime() - updatedAtDate.getTime()) / millisecondsPerDay );

        draftIsExpired = ageInDays > 3;
      }

      if (draftIsExpired) {
        console.log('*** WRP draft is older than 3 local calendar days; deleting it ***');

        await deleteWRPDraft(this.uId, this.token);

        validDraft = null;
      }
    }

    if (validDraft) {
      await this.loadDraft(validDraft);
    } else {
      // No valid draft: initialize a new WRP normally.
      this.program = await getProgramFromDbase(this.uId, this.token);

      this.latestWRP = await getLatestWRPFromDbase(this.uId, this.token);
    }

  },
}
</script>

<template>
<!-- alert: draft saved -->
<v-snackbar v-model="draftSaveShowAlert"
            :timeout="3500" closable
            color="blue" rounded="lg"
            location="top" elevation="6"
>WRP draft has been saved</v-snackbar>

<div id="wrp-page">

  <div id="page-header" class="px-2 py-4 d-flex justify-space-between align-center">
    <div>
      <h2>WRP</h2>
      <h3>Weekly Review / Preview</h3>
    </div>
    <div>
      <div class="d-flex flex-column flex-sm-row">
        <p class="me-2"><b>Date of Review:</b></p>
        <p><u>{{ dateOfReview?.display }}</u></p>
      </div>
      <div class="mt-3 d-flex justify-end">
        <v-btn @click.prevent="discardDraftStartOver"
               variant="text" size="small" color="grey"
               class="text-lowercase font-italic"
        >Discard Draft<br /> & Start Over</v-btn>
      </div>
    </div>

  </div>

  <div v-if="loadingDiscardDraft" id="container-for-loading-icon-discard-draft">
    <div class="d-flex h-100 w-100 justify-center align-top mt-16 pt-16">
      <v-progress-circular size="200" width="15" color="green-lighten-2" indeterminate></v-progress-circular>
    </div>
  </div>

  <div id="date-picker" class="px-2 d-flex flex-column">

    <!-- select reviewStartDate -->
    <div :class="{ 'd-none': wrpStarted }">
      <div class="d-flex align-center">
        <p id="dp-text" class="pb-5 pe-4 pe-sm-2 text-red-darken-4 text-sm-right font-weight-bold">
          Select First Day of Week to Review
        </p>
        <div id="dp-select">
          <v-select v-model="selectedReviewStartDate"
            :items="reviewStartDateOptions"
            @update:modelValue="handleChangeToReviewStartDate"

            item-title="display"
            item-value="value"
            variant="outlined"
            density="comfortable"
            color="red-darken-4"
          ></v-select>
        </div>
      </div>
    </div>

    <div class="my-4">

      <div class="mb-1 d-flex flex-column flex-sm-row align-start justify-sm-space-between align-sm-center">

        <p><b><u>Week to Review</u></b></p>
        <v-btn @click.prevent="openAllDaysToReviewInNewTabs"
               size="small"
               variant="outlined"
               color="blue-lighten-1"
               class="text-capitalize"
        >Open all Days to Review in new tabs</v-btn>
      </div>
      <CalWeekReview :weekToReview="weekToReview" />
    </div>

    <div class="my-4">
      <p><b><u>Week to Preview</u></b></p>
      <CalWeekPreview :weekToPreview="weekToPreview" />
    </div>

    <!-- Good To Go? -->
    <div :class="{ 'd-none': wrpStarted }">
      <div class="d-flex justify-space-between align-center mt-8">
        <p class="text-green-darken-2 font-italic text-body-2 pr-3">Good to Go? Everything look right? ----> </p>
        <v-progress-circular v-if="loading" color="green-lighten-3" indeterminate></v-progress-circular>
        <v-btn
          id="btn-start-wrp"
          class="bg-light-green-lighten-1 text-green-darken-4 px-12"
          @click.prevent="startWRP"
          :disabled="loading"
        >
          Start WRP
        </v-btn>
      </div>
    </div>

  </div> <!-- end #date-picker -->

  <div id="wrp-accordions-container" class="pt-8" :class="{'d-none': !wrpStarted}">
    <v-expansion-panels v-model="expandedStep">

      <!-- STEP 1: Target -->
      <v-expansion-panel id="wrp-accordion-1" value="1">
        <v-expansion-panel-title>
          Step 1 - Target for the Past Week
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <p class="font-weight-bold mb-4">
            Review: {{weekToReview[0].weekday}}, {{weekToReview[0].month}} {{weekToReview[0].day}} to {{weekToReview[6].weekday}}, {{weekToReview[6].month}} {{weekToReview[6].day}}
          </p>
          <div v-if="yesRecentWRPTarget">
            <p><b><u>Target /Goals for the Past Week (Week to Review)</u></b></p>
            <p class="wrp-pre-line ms-4" v-html="targetForThisPastWeek"></p>
          </div>
          <div v-else> <!-- !yesRecentWRPTarget -->

            <!-- Note, re: Target/Goals -->
            <div v-if="latestWRP">
              <p class="mt-4 mb-6 ms-4 text-red-darken-3 font-weight-bold">You did not have a Target / Goals set for this week.</p>
            </div>
            <div v-else>
              <p class="mt-4 mb-6 ms-4 text-green-darken-3 font-weight-bold">Congratulations! This is your first WRP - Weekly Review / Preview.</p>
            </div>

            <!-- On-The-Fly Target/Goal -->
            <div>
              <p><b><u>What WOULD HAVE Made This Past Week a WIN?</u></b></p>
              <v-textarea
                  v-model="onTheFlyTargetGoal"
                  placeholder="Target/Goals that made this week a WIN"
                  rows="2"
                  auto-grow
                  variant="outlined"
              ></v-textarea>
            </div>
          </div> <!-- end !yesRecentWRPTarget -->

          <!-- Did you Win the Week? -->
          <div class="mt-8">
            <p class="mb-2 pe-2"><b><u>Did You Hit Your Target / Goals This Past Week? Was This Week a Win?</u></b></p>
            <v-radio-group v-model="hitThisPastWeekTarget">
              <v-radio label="Yes" value="1"></v-radio>
              <v-radio label="No" value="0"></v-radio>
            </v-radio-group>
          </div>

          <!-- btn: next step -->
          <div class="d-flex justify-space-between align-center mt-4">
            <p class="text-body-2">Ready to Review the Past Week?</p>
            <v-btn @click.prevent="goToStep('2')"
                   color="blue-lighten-1"
                   class="text-capitalize"
            >Go to Next Step</v-btn>
          </div>

        </v-expansion-panel-text>
      </v-expansion-panel>


      <!-- STEP 2: Review this Past Week -->
      <v-expansion-panel id="wrp-accordion-2" value="2">
        <v-expansion-panel-title>
          Step 2 - Review This Past Week's Performance
        </v-expansion-panel-title>
        <v-expansion-panel-text class="py-8">
          <p class="font-weight-bold mb-4">
            Review: {{weekToReview[0].weekday}}, {{weekToReview[0].month}} {{weekToReview[0].day}} to {{weekToReview[6].weekday}}, {{weekToReview[6].month}} {{weekToReview[6].day}}
          </p>

          <!-- table: summary of week -->
          <v-table>
            <thead>
              <tr>
                <th></th>
                <th v-for="day in weekToReview" :key="day.value" class="border text-center font-weight-bold" style="min-width: 92px;">{{ day.weekday }}<br />{{ day.month }} {{ day.day }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in step2WinsSummaryTableRows" :key="row.label">
                <td class="border"><b>{{ row.label }}</b></td>
                <td v-for="cell in row.cells" :key="cell.date" class="border py-4 text-center">
                  <div v-html="cell.display"></div>
                  <v-icon v-if="cell.showCheck" color="success">mdi-check-circle</v-icon>
                  <v-icon v-if="cell.total && !cell.showCheck" color="error">mdi-close-circle</v-icon>
                </td>
              </tr>
            </tbody>
          </v-table>
          <!-- btn: see details by day (modal) -->
          <div class="my-4 mb-8 d-flex justify-end">
            <v-btn @click.prevent="showReviewDetailsByDay = true" size="small" variant="outlined">See Daily Wins Details</v-btn>
          </div>


          <!-- stacked graphics -->
          <StackedGraphics
            :stackedWins="stackedWins" :totalPossibleWins="totalPossibleWins"
            :stackedBigTasks="stackedBigTasks" :totalPossibleBigTasks="totalPossibleBigTasks"
            :stackedSmallTasks="stackedSmallTasks" :totalPossibleSmallTasks="totalPossibleSmallTasks"
          />


          <!-- // SELF-REVIEW -->
          <!-- rate your performance -->
          <div class="mb-12 mt-16">
            <p class="mb-4"><b><u>Rate Your Overall Performance This Past Week</u></b></p>
            <div class="d-flex justify-space-between">
              <div v-for="i in 5" :key="i"
                class="d-flex flex-column align-center justify-start"
              >
                <v-icon @click.prevent="selectPerformanceRating(i)"
                  :icon="rateYourPerformance >= i ? 'mdi-arm-flex' : 'mdi-arm-flex-outline'"
                  :color="rateYourPerformance >= i ? 'yellow-darken-2' : 'grey-lighten-1'"
                ></v-icon>
                <p class="text-wrap">{{ rateYourPerformanceDescriptions[i] }}</p>
              </div>
            </div>
          </div>
          <!-- unexpected obstacles -->
          <div class="my-6">
            <p class="mb-2"><b><u>Unexpected or Undesired Obstacles and Results? Frustrations?</u></b></p>
            <v-textarea
              v-model="unexpectedObstacles"
              label="Unexpected Obstacles"
              rows="2"
              auto-grow
              persistent-hint
              variant="outlined"
            ></v-textarea>
          </div>
          <!-- what helped? what worked? -->
          <div class="my-6">
            <p class="mb-2"><b><u>What Helped? What Made Things Better? What Worked for You?</u></b></p>
            <v-textarea
              v-model="whatWorkedForYou"
              label="What Worked for You"
              rows="2"
              auto-grow
              persistent-hint
              variant="outlined"
            ></v-textarea>
          </div>
          <!-- what would you do differently? -->
          <div class="my-6">
            <p class="mb-2 text-capitalize"><b><u>What could you have done better? What do you wish you had done differently?</u></b></p>
            <v-textarea
              v-model="whatWouldYouDoDifferently"
              label="What You Would Do Differently"
              rows="2"
              auto-grow
              persistent-hint
              variant="outlined"
            ></v-textarea>
          </div>


          <!-- btn: next step -->
          <div class="mt-4 d-flex justify-space-between align-center">
            <p class="pe-2 text-body-2">Ready to Preview the Upcoming Week?</p>
            <v-btn @click.prevent="goToStep('3')"
                   color="blue-lighten-1"
                   class="text-capitalize"
            >Go to Next Step</v-btn>
          </div>

        </v-expansion-panel-text>
      </v-expansion-panel>
      <!-- modal: stacked wins by day -->
      <v-dialog v-model="showReviewDetailsByDay" fullscreen>
        <v-card>
          <v-toolbar id="modal-stacked-wins-by-day-toolbar">
            <v-btn @click.prevent="showReviewDetailsByDay = false" icon="mdi-close"></v-btn>
            <v-toolbar-title>Stacked Wins by Day</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="px-0">
            <TableWins :modalWinsDetailTableRows="modalWinsDetailTableRows" :weekToReview="weekToReview" />

            <div class="my-8 pa-4 d-flex justify-end">
              <v-btn @click.prevent="showReviewDetailsByDay = false"
                     variant="outlined"
                     color="red-lighten-1"
                     density="compact"
                     class="px-2"
              >Close</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>


      <!-- STEP 3: Preview the Upcoming Week -->
      <v-expansion-panel id="wrp-accordion-3" value="3">
        <v-expansion-panel-title>
          Step 3 - Preview/Plan the Upcoming Week
        </v-expansion-panel-title>
        <v-expansion-panel-text class="py-8">
          <div class="mb-16 pb-4">
            <p class="font-weight-bold">Preview: {{weekToPreview[0].weekday}}, {{weekToPreview[0].month}} {{weekToPreview[0].day}} to {{weekToPreview[6].weekday}}, {{weekToPreview[6].month}} {{weekToPreview[6].day}}</p>
            <v-table class="border table-preview-tasks">
              <thead>
                <tr class="text-center font-weight-bold">
                  <th v-for="day in weekToPreview" :key="day.value" class="border-e text-center">
                    {{day.weekday}}<br />{{day.day}}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-for="(day, i) in dataWeekToPreview" :key="i" style="vertical-align: top;" class="border-e">
                    <ul v-if="day?.bigtask" class="ml-3">
                      <li class="preview-ul-tasks">
                        <b>BIG TASK >> {{ day.bigtask.title }}</b><br />
                        {{ day.bigtask.description }}
                      </li>
                    </ul>
                    <ul v-if="day?.smalltasks" class="ml-3">
                      <li v-for="(task, i) in day.smalltasks" :key="i" class="preview-ul-tasks">{{task.task}}</li>
                    </ul>
                    <ul v-if="newTasksAddedToUpcomingWeek[i]" class="ml-3">
                      <li v-for="(thing, k) in newTasksAddedToUpcomingWeek[i]" :key="k"  class="preview-ul-tasks">{{thing}}</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>

          <div id="preview-add-birthday" class="preview-add-container" :class="showPreviewAddField === '1' ? '' : 'd-none'">
            <h4>Add a Birthday</h4>
            <v-select
                v-model="addBirthdayDate"
                :items="weekToPreview"
                item-title="display"
                item-value="value"
                variant="outlined"
                density="comfortable"
            ></v-select>
            <v-textarea
              v-model="addBirthday"
              label="Add Name of Birthday Boy/Girl"
              variant="outlined"
              auto-grow
              persistent-hint
              rows="1"
            ></v-textarea>
            <div class="d-flex justify-space-between flex-wrap">
              <v-btn @click.prevent="showPreviewAddSection('2')" size="small">Done with Birthdays</v-btn>
              <v-btn @click.prevent="addNewBirthday" size="small">add birthday</v-btn>
            </div>
          </div>
          <div id="preview-add-personal" class="preview-add-container" :class="showPreviewAddField === '2' ? '' : 'd-none'">
            <h4>Add a Personal / Social Appointment</h4>
            <v-select
              v-model="addPersonalDate"
              :items="weekToPreview"
              item-title="display"
              item-value="value"
              variant="outlined"
              density="comfortable"
            ></v-select>
            <v-textarea
              v-model="addPersonal"
              label="Add Personal / Social Event"
              variant="outlined"
              auto-grow
              persistent-hint
              rows="1"
            ></v-textarea>
            <div class="d-flex justify-space-between flex-wrap">
              <v-btn @click.prevent="showPreviewAddSection('3')" size="small">Done with Personal Events</v-btn>
              <v-btn @click.prevent="addNewPersonal" size="small">add personal</v-btn>
            </div>
          </div>
          <div id="preview-add-main-task" class="preview-add-container" :class="showPreviewAddField === '3' ? '' : 'd-none'">
            <h4>Add a Main Task</h4>
            <v-select
              v-model="addMainTaskDate"
              :items="weekToPreview"
              item-title="display"
              item-value="value"
              variant="outlined"
              density="comfortable"
            ></v-select>
            <v-textarea
              v-model="addMainTaskTitle"
              label="Add Main Task Title"
              variant="outlined"
              auto-grow
              persistent-hint
              rows="1"
            ></v-textarea>
            <v-textarea
              v-model="addMainTaskDescription"
              label="Add Main Task Description"
              variant="outlined"
              auto-grow
              persistent-hint
              rows="3"
            ></v-textarea>
            <div class="d-flex justify-space-between flex-wrap">
              <v-btn @click.prevent="showPreviewAddSection('4')" size="small">Done with Daily Main Tasks</v-btn>
              <v-btn @click.prevent="addNewMainTask" size="small">add main task to a day</v-btn>
            </div>
          </div>
          <div id="preview-add-time-block" class="preview-add-container" :class="showPreviewAddField === '4' ? '' : 'd-none'">

            <h4>time block your week on your calendar app/day planner {{finishedTimeBlocking}}</h4>
<!--            <p>yes / no - radio (default no)</p>-->
            <v-radio-group v-model="finishedTimeBlocking" inline>
              <v-radio label="Yes" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>

            <div class="d-flex">
              <v-btn @click.prevent="showPreviewAddSection('5')" size="small">Done with Time Blocking</v-btn>
            </div>
          </div>

          <!-- btn: next step -->
          <div :class="showPreviewAddField === '5' ? '' : 'd-none'">
            <div class="d-flex mt-4 justify-space-between align-center">
              <p class="text-body-2 pe-2">Ready to set a Target for the Upcoming Week?</p>
              <v-btn @click.prevent="goToStep('4')"
                     color="blue-lighten-1"
                     class="text-capitalize"
              >Go to Next Step</v-btn>
            </div>
          </div>

        </v-expansion-panel-text>
      </v-expansion-panel>


      <!-- STEP 4: Main Target for Upcoming Week -->
      <v-expansion-panel id="wrp-accordion-4" value="4">
        <v-expansion-panel-title>
          Step 4 - Main Target, Goals for Upcoming Week
        </v-expansion-panel-title>
        <v-expansion-panel-text class="py-8">
          <p class="pb-2">target is the main big thing you WANT to happen. Goals are the little steps you can DO to get you to your target.</p>
          <p class="pb-4 font-weight-bold text-decoration-underline">What main target and goals would you have to hit to call this week a win?</p>
          <v-textarea
            v-model="mainTargetForUpcomingWeek"
            label="Add Main Task for the Upcoming Week"
            variant="outlined"
            auto-grow
            persistent-hint
            rows="3"
          ></v-textarea>

          <div class="d-flex justify-space-between align-center">
            <p class="text-body-2 pe-2">Finished setting your Target?</p>
            <v-btn @click.prevent="goToStep('5')"
                   color="blue-lighten-1"
                   class="text-capitalize"
            >Review & Save</v-btn>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>


      <!-- STEP 5: Review & Save -->
      <v-expansion-panel id="wrp-accordion-5" value="5">
        <v-expansion-panel-title>
          Step 5 - Confirm & Save
        </v-expansion-panel-title>
        <v-expansion-panel-text class="py-8">
<!--          <p>read only data vars > wrp object</p>-->
          <div class="mb-12 text-red-lighten-2 font-italic">
            <p><b>Does the Following Look Accurate?</b></p>
            <p>If not, then go back and fix it before saving.</p>
          </div>

          <!-- STEP 0 -->
          <p class="my-4">
            <b>Date of Review:</b> {{todayDateDisplay}}
          </p>
          <div class="my-4">
            <p><b>Review the Week of:</b></p>
            <CalWeekReview :weekToReview="weekToReview" />
          </div>
          <div class="my-4">
            <p><b>Preview the Week of:</b></p>
            <CalWeekPreview :weekToPreview="weekToPreview" />
          </div>

          <!-- STEP 1 -->
          <h3 class="mt-15 mb-6 text-decoration-underline">This Past Week</h3>
          <p class="my-6 wrp-pre-line">
            <b>Main Target/Goals for This Past Week:</b><br />
            <span v-if="yesRecentWRPTarget">{{targetForThisPastWeek}}</span>
            <span v-else>{{onTheFlyTargetGoal}}</span>
          </p>
          <p class="my-6">
            <b>Did You Hit That Target/Goals This Past Week:</b><br />
            <span v-if="hitThisPastWeekTarget === '1'">YES</span>
            <span v-else>No</span>
          </p>

          <!-- STEP 2 -->
          <div class="my-6">
            <p class="mb-2"><b>How Many Wins You STACKED This Past Week</b></p>
            <StackedGraphics
              :stackedWins="stackedWins" :totalPossibleWins="totalPossibleWins"
              :stackedBigTasks="stackedBigTasks" :totalPossibleBigTasks="totalPossibleBigTasks"
              :stackedSmallTasks="stackedSmallTasks" :totalPossibleSmallTasks="totalPossibleSmallTasks"
            />
          </div>

          <div class="my-6">
            <p class="mb-2"><b>Rate Your Performance This Past Week</b></p>
            <div class="d-flex justify-space-between">
              <div v-for="i in 5" :key="i" class="d-flex flex-column align-center justify-start">
                <v-icon
                  :icon="rateYourPerformance >= i ? 'mdi-arm-flex' : 'mdi-arm-flex-outline'"
                  :color="rateYourPerformance >= i ? 'yellow-darken-2' : 'grey-lighten-1'"
                ></v-icon>
                <p class="text-wrap">{{ rateYourPerformanceDescriptions[i] }}</p>
              </div>
            </div>
          </div>

          <div class="my-6">
            <p><b>Unexpected Obstacles You Faced This Past Week</b></p>
            <p class="wrp-pre-line">{{unexpectedObstacles}}</p>
          </div>

          <div class="my-6">
            <p><b>What Worked / Helped?</b></p>
            <p class="wrp-pre-line">{{whatWorkedForYou}}</p>
          </div>

          <div class="my-6">
            <p><b>What Would You Do Better / Differently Next Time?</b></p>
            <p class="wrp-pre-line">{{whatWouldYouDoDifferently}}</p>
          </div>


          <!-- STEP 3 -->
          <h3 class="mt-15 mb-6 text-decoration-underline">Upcoming Week</h3>
          <div class="my-6">
            <p class="mb-2"><b>Events Added to This Upcoming Week</b></p>
            <p class="ml-3 mb-1">{{addBirthdayCount}} Birthdays</p>
            <p class="ml-3 mb-1">{{addPersonalCount}} Personal / Social Events</p>
            <p class="ml-3 mb-1">{{addMainTaskCount}} Daily Main Goals</p>
          </div>
          <div class="my-6">
            <p class="mb-2"><b>Days Are Time-Blocked</b></p>
            <p>{{ finishedTimeBlocking ? 'Yes' : 'No' }}</p>
          </div>


          <!-- STEP 4 -->
          <div class="my-6">
            <p class="mb-2"><b>Main Target / Goal for Upcoming Week</b></p>
            <p class="wrp-pre-line">{{mainTargetForUpcomingWeek}}</p>
          </div>


          <!-- STEP 5: SAVE & FINISH -->
          <div class="mt-15 d-flex justify-space-between align-center">
            <p class="text-body-2 pe-2">Everything look correct?</p>

            <v-progress-circular v-if="loadingStep5"
                                 color="green-lighten-3" indeterminate
            ></v-progress-circular>

            <v-btn @click.prevent="finishAndSaveWRP"
                   :disabled="loadingStep5"
                   color="green-lighten-1"
            >Save & Finish</v-btn>
          </div>

        </v-expansion-panel-text>
      </v-expansion-panel>

    </v-expansion-panels>
  </div>

  <!-- IN-PAGE NAV - sticky-bottom -->
  <div v-if="wrpStarted"
       id="wrp-sticky-nav" class="d-flex justify-space-between align-center px-4 py-3"
  >
    <p class="ma-0 text-body-2 font-weight-bold">
      Step {{ expandedStep }} of 5
    </p>

    <div class="d-flex align-center">
      <v-progress-circular v-if="loadingSaveDraft"
                           class="me-3" size="24" width="3"
                           color="green-lighten-2" indeterminate
      ></v-progress-circular>

      <v-btn @click.prevent="saveDraft"
             color="green-darken-2"
             :disabled="loadingSaveDraft"
      >Save Draft</v-btn>
    </div>
  </div>

</div>
</template>

<style lang="scss" scoped>
#wrp-page {
  @media screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    margin: 0 auto;
    width: 600px;
    max-width: 600px;
  }

  .wrp-pre-line { white-space: pre-line; }

  #wrp-sticky-nav {
    position: sticky;
    z-index: 100;
    bottom: 0;

    background-color: white;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);

  }

}

#page-header {
  //background-color: lightgray;
  h2 {
    font-size: 72px;
    line-height: 69px;
    color: darkolivegreen;
  }
  p {
    font-size: 18px;
    u { text-decoration-style: double; }
  }
}

#container-for-loading-icon-discard-draft {
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
}

#date-picker {
  table {
    //th { font-size: 14px; }
    td { font-size: 15px; }
  }
  #dp-text { width: 40%;}
  #dp-select { width: 60%; }
  @media screen and (min-width: 600px) {
    #dp-text { width: 66%; }
    #dp-select { width: 33%; }
  }
}

#wrp-accordions-container {
  padding-bottom: 100px !important;
  $preview-task-min-width: 240px;
  // step 3
  .preview-ul-tasks {
    min-width: $preview-task-min-width;
    white-space: pre-line;
    margin-bottom: 12px;
  }
  .preview-add-container .d-flex .v-btn {
    margin-bottom: 12px;
  }
}

#modal-stacked-wins-by-day-toolbar {
  position: sticky;
  top: 0;
  z-index: 100;
}

</style>
